﻿import './src/sass/Bootstrap.scss';
import './shareit-library/dist/css/ShareItLibrary.css';
import './src/css/site.css';

import * as bootstrap from 'bootstrap';
(window as any).bootstrap = bootstrap;

import * as ShareItLibrary from 'shareit-library';
(window as any).sil = ShareItLibrary;

import './src/js/site';
import './src/js/SideNav';

